import {
    Box,
    Container,
    Typography,
    Paper,
    useTheme,
    Divider,
    List,
    ListItem,
    ListItemText
} from '@mui/material';

const Terms = () => {
    const theme = useTheme();

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
                <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                    Terms and Conditions
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" paragraph>
                    Last Updated: January 1, 2025
                </Typography>

                <Typography paragraph sx={{ mt: 4 }}>
                    Welcome to Total Turf Experience. By accessing or using our services, you agree to be bound by these Terms and Conditions.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    1. Acceptance of Terms
                </Typography>
                <Typography paragraph>
                    By accessing our website, registering for an account, or using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    2. Administrative Fees
                </Typography>
                <Typography paragraph>
                    2.1. Administrative fees are required for participation in our programs and facility access.
                </Typography>
                <Typography paragraph>
                    2.2. All fees must be paid in full before access to facilities or services is granted.
                </Typography>
                <Typography paragraph>
                    2.3. Fees are non-refundable unless otherwise specified or required by law.
                </Typography>
                <Typography paragraph>
                    2.4. We reserve the right to modify our fee structure with appropriate notice.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    3. Facility Access and Usage
                </Typography>
                <Typography paragraph>
                    3.1. Access to facilities is granted only to registered members with current, paid administrative fees.
                </Typography>
                <Typography paragraph>
                    3.2. Clients must follow all posted rules and staff instructions while using the facilities.
                </Typography>
                <Typography paragraph>
                    3.3. We reserve the right to deny access to anyone who violates our rules or poses a risk to others.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    4. Health and Safety
                </Typography>
                <Typography paragraph>
                    4.1. By using our facilities, you acknowledge and accept the inherent risks associated with physical activities.
                </Typography>
                <Typography paragraph>
                    4.2. You agree to the terms of our health waiver during the checkout process and by signing up for this administrative portal.
                </Typography>
                <Typography paragraph>
                    4.3. You must immediately report any injuries or safety concerns to staff.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    5. Account Management
                </Typography>
                <Typography paragraph>
                    5.1. You are responsible for maintaining the confidentiality of your account credentials.
                </Typography>
                <Typography paragraph>
                    5.2. You must provide accurate and current information during registration.
                </Typography>
                <Typography paragraph>
                    5.3. You must promptly update any changes to your account information.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    6. Limitation of Liability
                </Typography>
                <Typography paragraph>
                    6.1. We are not liable for any indirect, incidental, or consequential damages.
                </Typography>
                <Typography paragraph>
                    6.2. Our liability is limited to the amount paid for services in the preceding 12 months.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    7. Termination of Services
                </Typography>
                <Typography paragraph>
                    7.1. We reserve the right to terminate or suspend services for violation of these terms.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    8. Changes to Terms
                </Typography>
                <Typography paragraph>
                    8.1. We may modify these terms at any time with notice through our website.
                </Typography>
                <Typography paragraph>
                    8.2. Continued use of services after changes constitutes acceptance of modified terms.
                </Typography>

                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                    9. Contact Information
                </Typography>
                <Typography paragraph>
                    For questions about these Terms and Conditions, please contact:
                </Typography>
                <Typography>
                    Total Turf Experience<br />
                    614 Lambs Road<br />
                    Pitman, NJ 08071<br />
                    Phone: (856) 218-8091<br />
                    Email: info@totalturf.net
                </Typography>
            </Paper>
        </Container>
    );
};

export default Terms; 